import { Pipe, PipeTransform } from '@angular/core';
import { AppLocalizationService } from '@app/shared/common/localization/app-localization.service';
import { Duration } from 'luxon';

@Pipe({ name: 'luxonDurationLocalized' })
export class LuxonDurationLocalizedPipe implements PipeTransform {
  constructor(private readonly _appLocalization: AppLocalizationService) {

  }
  transform(value: Duration, includeEmpty = false, separator: string = ' '): string {
    const tokens: string[] = [];
    const { hours, minutes, seconds } = value;

    if (hours) {
      if (hours > 1) {
        tokens.push(this._appLocalization.l('Duration_Hours', hours));
      } else if (includeEmpty) {
        tokens.push(this._appLocalization.l('Duration_Hour', hours));
      }
    }

    if (minutes) {
      if (minutes > 1) {
        tokens.push(this._appLocalization.l('Duration_Minutes', minutes));
      } else if (includeEmpty) {
        tokens.push(this._appLocalization.l('Duration_Minute', minutes));
      }
    }

    if (seconds) {
      if (seconds > 1) {
        tokens.push(this._appLocalization.l('Duration_Seconds', seconds));
      } else if (includeEmpty) {
        tokens.push(this._appLocalization.l('Duration_Second', seconds));
      }
    }

    return tokens.join(separator);
  }
}
